
export const appLinks = {
  api: {
    BASE: '/api',
    CARD: '/api/v1/card',
    CARD_VCF: '/api/v1/card/vcf',
    CONTACT: '/api/v1/contact',
    PRICING: '/api/v1/pricing',
    CHAT_CONVERSATIONS: '/api/v1/chat/conversations/',
    M_RATING: '/api/v1/chat/messages/rating/',
    CHAT_STT: '/api/v1/chat/stt',
    ACCOUNT_DATA: '/api/v1/account/data',
    ACCOUNT_DATA_UPDATE: '/api/v1/account/data/update',
  },
  card: {
    LINK: '/card/',
  },
  common: {
    CGU: "/cgu",
    PRIVACY: "/privacy",
    ABOUT: "/about",
    CONTACT: "/contact",
    LOGIN: "/login",
    SIGNUP: "/signup",
    FAQ: "/faq",
  },
  account: {
    PROFILE: '/account/profile',
    REFILL: '/account/refill',
    HISTORY: '/account/history',
    INSTRUCTIONS: '/account/instructions',
    CARDS: '/account/cards',
    CHAT: '/account/chat',
    CONTACT: '/account/contact',
    SETTINGS: '/account/settings',
    MEMORY: '/account/memory',
    VOICE_AGENT: '/account/voice-agent',
    DATA_CONTROLS: '/account/settings/data',
    BILLING_INFO: '/account/settings/billing-info',
  }
}